import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import PhoneIcon from '@mui/icons-material/Phone';
import { translate } from '@openclassrooms/translations';
import ContactChannelButton from '../ContactChannelButton';
import { ContactContext, type ContactContextType } from '../ContactProvider';
export default function ContactChannelButtonPhone(t0) {
  const $ = _c(4);
  const {
    onClick
  } = t0;
  const {
    helpType
  } = useContext(ContactContext) as ContactContextType;
  const t1 = `Navigation|Redirection::Internal|support-panel|call-${helpType}`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = translate("support.global.contact_channel.call.title");
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== onClick || $[2] !== t1) {
    t3 = <ContactChannelButton iconComponent={PhoneIcon} onClick={onClick} data-event={t1}>{t2}</ContactChannelButton>;
    $[1] = onClick;
    $[2] = t1;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}